import gql from 'graphql-tag';

const getIndividualListGQL = gql`
  query ($instId: String!, $accountId: String!, $id: String!) {
    list(instId: $instId, accountId: $accountId, id: $id) {
      attributes
      id
      name
      accountId
      loadAttributes
      filters
      shared
      listType
    }
  }
`;

export default getIndividualListGQL;
